document.addEventListener('DOMContentLoaded', function() {
    const swNaturalsFaqToggles = document.querySelectorAll('[data-sw-naturals-faq-toggle]');
  
    swNaturalsFaqToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const faqItem = this.closest('.sw-naturals-faq-item');
        const faqAnswer = faqItem.querySelector('.sw-naturals-faq-answer');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
  
        // Close all other items (accordion behavior)
        swNaturalsFaqToggles.forEach(function(otherToggle) {
          const otherItem = otherToggle.closest('.sw-naturals-faq-item');
          const otherAnswer = otherItem.querySelector('.sw-naturals-faq-answer');
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
            otherItem.classList.remove('sw-naturals-active');
            otherAnswer.style.maxHeight = null;
          }
        });
  
        // Toggle current item
        this.setAttribute('aria-expanded', !isExpanded);
        faqItem.classList.toggle('sw-naturals-active', !isExpanded);
  
        if (!isExpanded) {
          // Open with animation
          faqAnswer.style.maxHeight = faqAnswer.scrollHeight + "px";
        } else {
          // Close with animation
          faqAnswer.style.maxHeight = null;
        }
      });
    });
    const swiper = new Swiper('.sw-naturals-ingredients-slider', {
      loop: true,                  // continuous loop
    slidesPerView: 1.1,          // show 2 full + a little of the next one
    spaceBetween: 14,            // gap between slides
    centeredSlides: false,       // align slides from top, not center
    freeMode: true,              // smooth scrolling (no snapping)
    // autoplay: {
    //   delay: 100000,               // auto-slide every 3s
    //   disableOnInteraction: false
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    speed: 600,
     breakpoints: {
    0:{
             slidesPerView: 1.1,
            spaceBetween: 14, 
    },
    520: {
      slidesPerView: 2.1,
        spaceBetween: 13, 
    }
  } 
    });
  
    const reviewswiper = new Swiper('.sw-amp-review-testimonials-swiper', {
  loop: true,                  
  slidesPerView: 1.4,          
  spaceBetween: 10,            
  centeredSlides: false,       
  freeMode: true,  
  pagination: false,    
  speed: 600,
  breakpoints: {
    0: {
      slidesPerView: 1.2,  
      spaceBetween: 6
    },
    370: {
      slidesPerView: 1.4,
      spaceBetween: 10
    }
    ,
    520: {
      slidesPerView: 2.1,
      spaceBetween: 10
    }
  }
});


    // Custom style for hiding cart drawer
 
 

  });
